import { render } from "./PopUpChooseResource.vue?vue&type=template&id=31c2bf1d"
import script from "./PopUpChooseResource.vue?vue&type=script&lang=js"
export * from "./PopUpChooseResource.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__